// SPDX-License-Identifier: AGPL-3.0-or-later

import { apiFetch } from './client.js';

/**
 * Authoring-time form translation (bead 7sp). Posts a batch of source
 * strings to /api/translate; the response holds matching translations
 * in the same order. Once the clinician accepts the draft and hits
 * Save Form, the translation is persisted on the questionnaire — no
 * further server call happens on the patient-facing path.
 */

export interface TranslateInput {
  sources: string[];
  targetLang: string;
  sourceLang?: string;
}

export interface TranslateResponse {
  providerKind: string;
  translations: string[];
}

export async function translateBatch(input: TranslateInput): Promise<TranslateResponse> {
  return apiFetch<TranslateResponse>('/api/translate', {
    method: 'POST',
    body: input,
  });
}
